module.exports = __webpack_public_path__ + "media/images/new_home/business-detail-663033ecacfe6062219bf8a367436d7a.jpg";